import { __decorate } from "tslib";
import DateFilter from "@/components/DateFilter.vue";
import mobileFiltersModal from "@/components/mobileFiltersModal.vue";
import PerPage from "@/components/PerPage.vue";
import SimpleTable from "@/components/SimpleTable.vue";
import ModalMixin from '@/mixins/modal-mixin';
import { Component, Mixins, Prop } from 'vue-property-decorator';
let UserBalanceHistoryComponent = class UserBalanceHistoryComponent extends Mixins(ModalMixin) {
    userId;
    dates = {};
    currentPage = 1;
    perPageQuery = 20;
    sortField = 'createdAt';
    sortOrder = -1;
    get paramsQuery() {
        const query = {
            userId: this.userId
        };
        if (this.dates.start) {
            query.createdAt = { $lte: this.dates.end, $gte: this.dates.start };
        }
        query.$limit = this.perPageQuery;
        query.$skip = (this.currentPage - 1) * this.perPageQuery;
        query.$sort = { [this.sortField]: this.sortOrder };
        return query;
    }
    get columns() {
        return [
            {
                name: 'createdAt',
                label: this.$t('Created at').toString(),
                field: (item) => this.$moment(item.createdAt).format('lll'),
                sortable: true,
            },
            {
                name: 'customer',
                label: this.$t('Customer').toString(),
                field: (item) => item.customer ? `${item.customer.first_name} ${item.customer.last_name}` : '',
                sortable: true,
            },
            {
                name: 'treatment',
                label: this.$t('Service').toString(),
                field: (item) => item.treatment?.label,
                sortable: true,
            },
            {
                name: 'percent',
                label: this.$t('Interest').toString(),
                field: (item) => item.change > 0 ? `${item.revenuePercent} %` : ''
            },
            {
                name: 'change',
                label: this.$t('Revenue').toString(),
                field: (item) => item.change,
                classes: (item) => item.cancelled ? 'text-muted' : item.change < 0 ? 'text-danger' : '',
                subtitle: (item) => (item.cancelled ? `<span class="badge badge-danger badge-pill"> ${this.$t('Cancelled')} </span>` : ''),
                sortable: true,
                money: true,
            },
            {
                name: 'balanceAfter',
                label: this.$t('Balance').toString(),
                field: (item) => item.balanceAfter,
                classes: (item) => item.cancelled ? 'text-muted' : '',
                sortable: true,
                money: true,
            },
        ];
    }
    onSortChanged(column, order) {
        this.sortField = column;
        this.sortOrder = order;
    }
};
__decorate([
    Prop({ type: String, required: true })
], UserBalanceHistoryComponent.prototype, "userId", void 0);
UserBalanceHistoryComponent = __decorate([
    Component({
        name: 'UserBalanceHistory',
        components: {
            PerPage,
            DateFilter,
            SimpleTable,
            mobileFiltersModal,
        }
    })
], UserBalanceHistoryComponent);
export default UserBalanceHistoryComponent;
